// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__pzfmZ","messages":"Chat_messages__2NL6b","dateDivider":"Chat_dateDivider__Lsl8D"};